export const config = {
  title: "Stivers",
  company_logo: "stivers.png",
  logo_placements: ["Right Sleeve", "Left Chest", "Front Center","Full Front"],
  show_modification_thumbnail: true,
  minimum_apparel_order: false,
  render_logo_preview: true,
  embroideries: {
    hat: [
      "Stivers",
      "Quicklane",
      "Ford",
      "Hyundai",
      "Chrysler",
      "Dodge",
      "Jeep",
      "Ram",
    ],
    mens: [
      "Stivers",
      "Quicklane",
      "Subaru",
      "Stivers Ford South",
      "Stivers Ford Birmingham",
      "Stivers Montgomery",
      "Stivers Prattville",
    ],
    womens: [
      "Stivers",
      "Quicklane",
      "Subaru",
      "Stivers Ford South",
      "Stivers Ford Birmingham",
      "Stivers Montgomery",
      "Stivers Prattville",
    ],
    accessory: [
      "Ford",
      "Hyundai",
      "Chrysler",
      "Dodge",
      "Jeep",
      "Ram",
      "Subaru",
    ],
    tshirt: ["Stivers Important Job"],
    customs: [],
  },
  email_recipients: ["lbudbill@gpcorp.com", "lbudbell@comcast.net","mmcord@gpcorp.com"],
  stores: [
    {
      name: "Stivers Ford Montgomery",
      address: "4000 Eastern Blvd Montgomery, AL, 36116",
      code: "STIFMO",
    },
    {
      name: "Stivers Ford Birmingham",
      address: "500 Palisades Blvd, Birmingham, AL, 35209",
      code: "STIFBI",
    },
    {
      name: "Stivers Hyundai",
      address: "9950 Farrow Rd, Columbia, SC, 29203",
      code: "STIHCO",
    },
    {
      name: "Stivers CDJR",
      address: "2209 Cobbs Ford Rd, Prattville, AL 36066",
      code: "STICPR",
    },
    {
      name: "Stivers Decatur Subaru",
      address: "1950 Orion Dr, Decatur, GA 30033",
      code: "STISDE",
    },
    {
      name: "Stivers Chevrolet",
      address: "111 Newland Road, Columbia, SC 29229",
      code: "STICCO",
    },
    {
      name: "Stivers Ford South Atlanta",
      address: "4355 Jonesboro Rd, Union City, GA 30291",
      code: "STIFSO",
    },
    {
      name: "Stivers Ford Troy",
      address: "121 US-231, Troy, AL 36081",
      code: "STIFTR",
    },
  ],
  bypass_codes: ["EMPLOYEE", "MANAGER"],

  server_hostname: "https://mxfj3q6m01.execute-api.us-east-1.amazonaws.com",
  account_reps: [
    { name: "Louis Budbill", phone: "678-287-1659" },
    { name: "Molly McCord", phone: "770-448-6982 ext.209" },
  ],
  route_prefix: "/stivers",
  paypal_not_supported: false,
  password: "StiverS",
};
